/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
export let CommitmentErrorMessage = /*#__PURE__*/function (CommitmentErrorMessage) {
  CommitmentErrorMessage["NO_COMMITMENT"] = "Title commitment must be uploaded to save & display in Blend.";
  CommitmentErrorMessage["NO_REPORT"] = "Title report must be uploaded to save & display in Blend.";
  CommitmentErrorMessage["SAVE_FAILURE"] = "Failed to save curative data, please try again.";
  return CommitmentErrorMessage;
}({});